import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';

/**
 * 2120. ダッシュボード（担当者別ランキング）
 * [GET] /workspaces/:identifier/dashboard/amount_by_user
 */
type Props = {
  identifier: string;
  team_ids?: number[];
  user_ids?: number[];
  product_ids?: number[];
  sales_context_ids?: number[];
};

export type DashboardAmountByUser = {
  total_amount: number;
  user_rankings: { name: string; total_amount: number; contracted_amount: number }[];
};

const dashboardAmountByUser = (props: Props): Promise<DashboardAmountByUser> => {
  return axios.get(`/api/workspaces/${props.identifier}/dashboard/amount_by_user`, { params: props });
};

export const useDashboardAmountByUser = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'dashboard', 'amount_by_user', { ...props }],
    queryFn: () => dashboardAmountByUser(props),
    staleTime: 1000 * 60 * 30,
  });
};
